export enum CheckboxTableColumnTitlePlacement {
  Left = 'left',
  Right = 'right',
  Center = 'center'
}

export enum CheckboxTableRowTitlePlacement {
  Left = 'left',
  Right = 'right',
  Center = 'center'
}

export enum CheckboxTableItemPlacement {
  Left = 'left',
  Right = 'right',
  Center = 'center'
}

export const columnOptions = [
  {
    key: 'Left',
    value: 'left'
  },
  {
    key: 'Center',
    value: 'center'
  },
  {
    key: 'Right',
    value: 'right'
  }
];

export const rowOptions = [
  {
    key: 'Left',
    value: 'left'
  },
  {
    key: 'Center',
    value: 'center'
  },
  {
    key: 'Right',
    value: 'right'
  }
];

export const itemOptions = [
  {
    key: 'Left',
    value: 'left'
  },
  {
    key: 'Center',
    value: 'center'
  },
  {
    key: 'Right',
    value: 'right'
  }
];
